import { createFileRoute } from '@tanstack/react-router';

import { ScreenGuard } from '~/components/common/screen-guard/screen-guard';
import { OrganizationLayout } from '~/features/organization/components/organization-layout';
import { requireTenantAdmin } from '~/utils/guards';

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary')({
  beforeLoad: requireTenantAdmin(),
  component: () => (
    <ScreenGuard>
      <OrganizationLayout />
    </ScreenGuard>
  ),
});
